/**
 * Single source of truth for environment configuration.
 *
 * All process.env access is centralized here so the rest of the app never
 * reads process.env directly. Switching environments only requires changing
 * the .env file values, never code.
 */

const toBool = (value, fallback = false) => {
  if (value === undefined || value === null || value === '') return fallback;
  return String(value).toLowerCase() === 'true';
};

const toNumber = (value, fallback) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
};

export const ENV = {
  NAME: process.env.REACT_APP_ENV || 'development',
  APP_NAME: process.env.REACT_APP_NAME || 'JYOT Console',
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1',
  API_TIMEOUT: toNumber(process.env.REACT_APP_API_TIMEOUT, 30000),
  API_RETRY_COUNT: toNumber(process.env.REACT_APP_API_RETRY_COUNT, 2),
  USE_MOCK: toBool(process.env.REACT_APP_USE_MOCK, true),
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
};

export default ENV;
